
export const getSelf = state => {
	return state.self;
}

export const getGroupID = state => {
	return state.groupID;
}

export const getPeers = state => {
	return state.peers;
}

export const getObjects = state => {
	return state.objects //.sort((a,b) => a.z_index - b.z_index);
}

export const getRooms = state => {
	return state.rooms;
}

export const isConnected = state => {
	return state.connected;
}

export const isMuted = state => {
	return state.self.muted;
}

export const audioContext = state => {
    return state.audioContext;
}

// fixing safari issue where MediaStream constructor does not exist
export const emptyStream = state => {
    return state.emptyStream;
}

export const getBoombox = state => {
	return state.boombox;
}

// get person who has been in room the longest
export const getVIP = state => {
	let people = Object.values(state.peers).concat(state.self);
	people.sort((a, b) => a.order - b.order);

	return people.length == 1 ? null : people[0];
}

export const menu = state => {
	return state.menu;
}

export const webAudioOutputStream = state => {
	return state.webAudioOutputStream;
}

export const combinedOutputStream = state => {
	return state.combinedOutputStream;
}

export const objectMode = state => {
	return state.objectMode;
}

export const audioDeviceExists = state => {
	return state.self.tracks.audio != undefined;
}

export const view = state => {
	return state.view;
}